import type { Structure } from '@wix/thunderbolt-becky-types'
import type { ViewerClientSpecMap } from '@wix/thunderbolt-symbols'
import type { BuilderComponentsHierarchy } from './builderComponentHierarchy'

export const getBuilderComponentsInStructure = (structure: Structure) => {
	const builderComponentsInStructure = new Set<string>()
	for (const compId in structure) {
		const comp = structure[compId]
		if (comp.builderType) {
			builderComponentsInStructure.add(comp.builderType)
		}
	}
	return builderComponentsInStructure
}

export const getAllBuilderComponentsOnPage = (builderComponentsInStructure: Set<string>, compTypeToAllDescendants: BuilderComponentsHierarchy) =>
	new Set(
		Array.from(builderComponentsInStructure).flatMap((compType) => [
			compType,
			...(compTypeToAllDescendants[compType] || []),
		]),
	)

export type BuilderComponentsOnPageImports = {
	client: Array<Record<string, string>>
	server: Array<Record<string, string>>
	sdk: Array<Record<string, string>>
}

export const buildBuilderComponentsOnPageImports = (
	clientSpecMap: ViewerClientSpecMap,
	allBuilderComponentsOnPage: Set<string>
): BuilderComponentsOnPageImports => {
	const imports: BuilderComponentsOnPageImports = {
		client: [],
		server: [],
		sdk: []
	}

	Object.values(clientSpecMap).forEach((app) => {
		app.components?.forEach((comp) => {
			if (comp.type === 'EDITOR_REACT_COMPONENT') {
				const builderType = comp.data.type
				if (allBuilderComponentsOnPage.has(builderType)) {
					const { resources } = comp.data
					const moduleSpecifier = resources.client?.moduleSpecifier
					const componentUrl = resources.client?.componentUrl
					const serverUrl = resources.server?.url
					const sdkUrl = resources.sdk?.url

					if (moduleSpecifier && componentUrl) {
						imports.client.push({ [moduleSpecifier]: componentUrl })
					}
					if (moduleSpecifier && serverUrl) {
						imports.server.push({ [moduleSpecifier]: serverUrl })
					}
					if (moduleSpecifier && sdkUrl) {
						imports.sdk.push({ [`${moduleSpecifier}/sdk`]: sdkUrl })
					}
				}
			}
		})
	})

	return imports
}
